<template>
  <div id="app">
    <h3>Vue-img-slider  Horizental</h3>
    <vue-img-slider
      style="width: 100%;height: 400px;"
      :type="'left'"
      margin="'20px'"
      :speed="10"
      :imgData="demoData"
      :txtPos="['40%','10%']"
    ></vue-img-slider>

    <h3>Vue-img-slider  Vertical</h3>
    <vue-img-slider
      style="width: 400px;height: 400px;margin-left: 400px"
      :type="'top'"
      margin="'20px'"
      :speed="10"
      :imgData="demoData"
      :txtPos="['40%','10%']"
    ></vue-img-slider>
  </div>
</template>

<script>
  import VueImgSlider from './components/VueImgSlider.vue'

  export default {
    name: 'app',
    data: function () {
      return {
        demoData: [
          {
            img: 'http://f12.baidu.com/it/u=1981748892,3031683197&fm=72',
            title: '图片1'
          },
          {
            img: 'http://f10.baidu.com/it/u=3243370105,1125765815&fm=72',
            title: '图片2'
          },
          {
            img: 'http://f12.baidu.com/it/u=1981748892,3031683197&fm=72',
            title: '图片3'
          },
          {
            img: 'http://f10.baidu.com/it/u=3243370105,1125765815&fm=72',
            title: '图片4'
          },

          ]
      }
    },
    components: {
      VueImgSlider
    }
  }
</script>

<style>
  #app {
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// App.vue?084bac25